import ExecutionEnvironmentResolver from './ExecutionEnvironmentResolver';

export { ENVIRONMENT } from './ExecutionEnvironmentName';
export { default as ExecutionEnvironment } from './ExecutionEnvironment';
export { ExecutionEnvironmentResolver };

/**
 * Resolves the execution environment for the current browser session.
 * @returns {import('./ExecutionEnvironment').default}
 */
export function resolveExecutionEnvironment() {
  return ExecutionEnvironmentResolver.resolve();
}
